import { memberAreaUserAccessDataLayerEvent } from '@front/common/data-layer-events'
import { getAuthStatus } from '@front/common/endpoints'
import { StatusType } from '@front/common/types'

import { MEMBER_AREA_ROUTE_LOGIN } from '@member-area/core/routes-names'

// @TODO: Migrate middleware for vue-router navigation guards avoiding any nuxt relation
export default async ({ redirect, route, store }) => {
  const { withAuth = false } = route.meta.find((meta) => meta.withAuth) || {}

  if (!withAuth) {
    return
  }

  try {
    const { status, id, roles } = await getAuthStatus(route.query?.id)

    if (status === StatusType.authenticated) {
      memberAreaUserAccessDataLayerEvent()
      store.dispatch('auth/set', { status, id, roles })
      return
    }

    redirect({ name: MEMBER_AREA_ROUTE_LOGIN, query: { to: route.fullPath } })
  } catch (e) {
    console.error(e)
  }
}
